package horcrux.frontend.common.views.chat

import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.MaybeState
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.views.components.containers.HStack
import js.objects.jso
import mui.icons.material.ArrowCircleUpOutlined
import mui.icons.material.Settings
import mui.icons.material.StopCircleOutlined
import mui.material.Box
import mui.material.FormControlVariant
import mui.material.IconButton
import mui.material.InputAdornment
import mui.material.InputAdornmentPosition
import mui.material.InputBaseProps
import mui.material.SvgIconSize
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import react.create
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.Position
import web.cssom.ZIndex
import web.cssom.pct
import web.cssom.pt

external interface InputChatPromptProps : Props {
    var globalAppState: GlobalAppState
}

val InputChatPrompt = FC<InputChatPromptProps> { props ->
    val isLoadingState = props.globalAppState.submitMessageIconIsLoadingState
    val inputPromptMaybeState = MaybeState<InputPrompt>()
    val showEditChatModelConfigsDialogState = BooleanState()
    val promptSubmitter = PromptSubmitter(props.globalAppState)
    EditChatModelConfigsDialog {
        this.showDialogState = showEditChatModelConfigsDialogState
        this.chatModelConfigsState = props.globalAppState.chatModelConfigsState
    }
    Box {
        this.sx {
            this.display = Display.flex
            this.justifyContent = JustifyContent.center
        }
        EditInputPrompt {
            this.textFieldValueMaybeState = inputPromptMaybeState
            this.textFieldPropsMaybe = jso {
                this.name = "input_prompt"
                this.id = "input_prompt"
                this.label = ReactNode("Message The Grok App")
                this.maxRows = 5
                this.multiline = true
                this.autoFocus = true
                this.variant = FormControlVariant.outlined
                this.value = inputPromptMaybeState.get() ?: ""
                this.inputRef = props.globalAppState.inputPromptRef
                this.sx {
                    this.position = Position.fixed
                    this.bottom = 0.pt
                    this.zIndex = 1000.unsafeCast<ZIndex>()
                    this.backgroundColor = StaticContentConfigs.WHITE
                    this.width = 95.pct
                }
                this.onKeyDown = {
                    if (it.key == "Enter") {
                        it.preventDefault()
                        props.globalAppState.currentCollectionMetadataMaybeState.get()?.let { collectionMetadata ->
                            promptSubmitter.onSubmitPromptAction(
                                inputPromptMaybeState = inputPromptMaybeState,
                                collectionMetadata = collectionMetadata
                            )
                        }
                    }
                }
                asDynamic().InputProps = jso<InputBaseProps> {
                    this.endAdornment = InputAdornment.create {
                        this.position = InputAdornmentPosition.end
                        HStack {
                            IconButton {
                                if (isLoadingState.get()) {
                                    StopCircleOutlined {
                                        this.onClick = { promptSubmitter.onCancelRequestAction() }
                                        this.fontSize = SvgIconSize.large
                                        this.sx {
                                            this.color = StaticContentConfigs.BLUE
                                        }
                                    }
                                } else {
                                    ArrowCircleUpOutlined {
                                        this.onClick = {
                                            props.globalAppState.currentCollectionMetadataMaybeState.get()
                                                ?.let { collectionMetadata ->
                                                    promptSubmitter.onSubmitPromptAction(
                                                        inputPromptMaybeState = inputPromptMaybeState,
                                                        collectionMetadata = collectionMetadata
                                                    )
                                                }
                                        }
                                        this.fontSize = SvgIconSize.large
                                        this.sx {
                                            this.color = StaticContentConfigs.BLUE
                                        }
                                    }
                                }
                            }
                            IconButton {
                                Settings {
                                    this.fontSize = SvgIconSize.large
                                    this.sx {
                                        this.color = StaticContentConfigs.BLUE
                                    }
                                    this.onClick = { showEditChatModelConfigsDialogState.setTrue() }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
